import type { GQL_ID, NestedFilter } from '@@partner:graphql/types'

import React, { useCallback } from 'react'
import { prepareCategoriesFilter } from '@@partner:helpers/category'

import {
  FilterPanel,
  createFilter,
  FilterConfig
} from '../../../common/filter'

// ===== ТИПЫ =====

export interface CategoriesFiltersType {
  ids: GQL_ID[]
  xid: GQL_ID[]
  name: string
}

export interface CategoriesFilterProps {
  onFilterChanged: (filters: NestedFilter) => void
}

// ===== КОНСТАНТЫ =====

const DEFAULT_STATE: CategoriesFiltersType = {
  ids: [],
  xid: [],
  name: ''
}

// ===== КОНФИГУРАЦИЯ ФИЛЬТРОВ =====

const FILTERS_CONFIG: FilterConfig[] = [
  createFilter.text('name', 'Название'),

  createFilter.multiline('ids', 'ID по одному на строку', {
    rows: 2,
    linePattern: /^\d+$/
  }),

  createFilter.multiline('xid', 'ID учетной системы по одному на строку', {
    rows: 2
  })
]

// ===== КОМПОНЕНТ =====

export default function CategoriesFilter ({
  onFilterChanged
}: CategoriesFilterProps) {
  const handleSearch = useCallback((state: CategoriesFiltersType) => {
    onFilterChanged(prepareCategoriesFilter(state))
  }, [ onFilterChanged ])

  return (
    <FilterPanel<CategoriesFiltersType>
      filters={FILTERS_CONFIG}
      defaultState={DEFAULT_STATE}
      onSearch={handleSearch}
    />
  )
}